"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailTwoTone = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var EmailTwoTone = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { fill: "currentColor", d: "M24 8.237l-11.641 6.35a.75.75 0 01-.719 0L0 8.236v11.264A1.5 1.5 0 001.5 21h21a1.5 1.5 0 001.5-1.5V8.237z", opacity: "0.72" }),
    react_1.default.createElement("path", { fill: "currentColor", d: "M1.5 3A1.5 1.5 0 000 4.5v1.174l11.904 6.493a.2.2 0 00.191 0L24 5.673V4.5A1.5 1.5 0 0022.5 3h-21z" }))); };
exports.EmailTwoTone = EmailTwoTone;
//# sourceMappingURL=email-two-tone.js.map